<template>
  <v-tabs>
    <v-tab>Call</v-tab>
    <v-tab>Email</v-tab>
    <v-tab class="tab">
      Text
      <div v-if="messageNotifications.length > 0" class="tab__icon">
        {{ messageNotifications.length }}
      </div>
    </v-tab>
    <v-tab v-if="lead.type_id == 2">Carrier</v-tab>
    <v-tab>Application</v-tab>
    <v-tab>FollowUps</v-tab>
    <v-tab-item>
      <v-sheet :width="'100%'" :elevation="4">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-tabs>
                <v-tab>Script</v-tab>
                <v-tab>History</v-tab>
                <v-tab class="tab">
                  VM
                  <div
                    v-if="
                      voicemailNotifications.length > 0 &&
                      lead.id === voicemailNotifications[0].lead_id
                    "
                    class="tab__icon"
                  >
                    {{ voicemailNotifications.length }}
                  </div>
                </v-tab>
                <v-tab>Notes</v-tab>
                <v-tab v-for="(script, index) in scripts" :key="script.id">
                  Script {{ index + 1 }}
                </v-tab>
                <v-spacer />
                <v-tab>Add a Custom Script</v-tab>
                <v-tab-item>
                  <ScriptTermLife
                    :lead="lead"
                    :baseData="baseData"
                    :sectionCount="sectionCount"
                    v-if="lead.term != 'fex'"
                  />
                  <ScriptFex
                    :lead="lead"
                    :baseData="baseData"
                    :sectionCount="sectionCount"
                    v-if="lead.term == 'fex'"
                  />
                  <v-divider class="mt-3" />
                  <div
                    class="btn-wrapper btn-wrapper_mb_0"
                    v-bind:class="{ 'btn-wrapper_right': !sectionCount }"
                  >
                    <v-btn
                      class="btn-next"
                      @click="prevSection"
                      v-if="sectionCount > 0"
                      >Prev section</v-btn
                    >
                    <v-btn
                      class="btn-next"
                      @click="nextSection"
                      v-if="sectionCount < 4"
                      >Next section</v-btn
                    >
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <CallHistory />
                </v-tab-item>
                <v-tab-item> <VoicemailsTab /></v-tab-item>
                <v-tab-item>
                  <v-container>
                    <p>Prev notes:</p>
                    <NoteContainer
                      emptyText="Not notes"
                      :deleteFunction="deleteNote"
                      :messages="notes"
                    />
                    <NoteForm
                      :send="createNote"
                      :messages="notes"
                      label="Notes"
                      btnText="Save"
                      class="mt-5"
                    />
                  </v-container>
                </v-tab-item>
                <v-tab-item v-for="script in scripts" :key="script.id">
                  <CustomScript
                    :script_id="script.id"
                    :lead="lead"
                    :html="script.html"
                  />
                </v-tab-item>
                <v-tab-item>
                  <CustomScriptGenerator :agent_id="agent_id" />
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-tab-item>
    <v-tab-item> <EmailTab /> </v-tab-item>
    <v-tab-item> <TextTab /> </v-tab-item>
    <v-tab-item v-if="lead.type_id == 2">
      <CarrierList />
    </v-tab-item>
    <v-tab-item>
      <Application />
    </v-tab-item>
    <v-tab-item>
      <FollowUps :lead_id="lead.id" :user_id="user.id" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NoteContainer from "@/components/messages/note/NoteContainer";
import NoteForm from "@/components/messages/note/NoteForm";
import ScriptFex from "@/components/lead/agent/scripts/ScriptFex";
import ScriptTermLife from "@/components/lead/agent/scripts/ScriptTermLife";
import CustomScriptGenerator from "@/components/lead/agent/scripts/CustomScriptGenerator";
import CustomScript from "@/components/lead/agent/scripts/CustomScript";
import CallHistory from "@/components/lead/agent/tabs/CallHistory";
import EmailTab from "@/components/lead/agent/tabs/EmailTab";
import CarrierList from "@/components/lead/agent/tabs/CarrierList";
import Application from "@/components/lead/agent/tabs/Application";
import TextTab from "@/components/lead/agent/tabs/TextTab";
import VoicemailsTab from "@/components/lead/agent/tabs/VoicemailsTab";
import FollowUps from "@/components/lead/agent/tabs/Followups";

export default {
  name: "PersonInfo",
  inject: ["theme"],
  components: {
    NoteContainer,
    NoteForm,
    CustomScriptGenerator,
    CustomScript,
    ScriptFex,
    ScriptTermLife,
    CallHistory,
    EmailTab,
    CarrierList,
    Application,
    TextTab,
    VoicemailsTab,
    FollowUps,
  },
  props: {
    lead: Object,
    source: String,
    agent_id: Number,
    baseData: Object,
  },
  data() {
    return {
      sectionCount: 0,
    };
  },
  methods: {
    ...mapActions({
      deleteNote: "notes/deleteNote",
      createNote: "notes/createNote",
      getCustomersVoiceMails: "voicemails/getCustomersVoiceMails",
      loadMessageNotifications: "notifications/loadMessageNotifications",
      loadVoicemailsNotifications: "notifications/loadVoicemailsNotifications",
    }),
    nextSection() {
      this.sectionCount++;
    },
    prevSection() {
      this.sectionCount--;
    },
  },
  mounted() {
    if (this.lead.id !== undefined) {
      this.loadMessageNotifications({
        user_id: this.user.id,
        lead_id: this.lead.id,
      });
      this.loadVoicemailsNotifications({
        user_id: this.user.id,
        lead_id: this.lead.id,
      });
    }

    this.sockets.subscribe("RECEIVE_MESSAGE", (notification) => {
      if (notification.lead_id === this.lead.id) {
        this.messageNotifications.push(notification);
      }
    });

    this.sockets.subscribe("CREATE_CUSTOMER_VOICE_MAIL", (notification) => {
      if (this.lead.id === notification.lead_id) {
        this.getCustomersVoiceMails(this.lead.id);
        this.voicemailNotifications.push(notification);
      }
    });
  },
  computed: {
    ...mapGetters({
      notes: "notes/notes",
      scripts: "lead/scripts",
      user: "auth/user",
      messageNotifications: "notifications/messageNotifications",
      voicemailNotifications: "notifications/voicemailNotifications",
    }),
  },
};
</script>

<style lang="scss">
.script-text {
  max-height: 600px;
  overflow: auto;
}

.btn-wrapper {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &_right {
    justify-content: flex-end;
  }
  &_mb_0 {
    margin-bottom: 0 !important;
  }
}
.tab {
  position: relative;
  &__icon {
    position: absolute;
    width: 18px;
    height: 18px;
    top: 1px;
    right: 1px;
    background-color: red;
    display: flex;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 12px;
    letter-spacing: 0.01em;
  }
}
</style>